import { TemplateRef } from '@angular/core';
import { ApiService } from '../../../services/api.service';
import { AuthenticationService } from '../../../services/authentication.service';
import { DepartmentListDetailComponent } from '../department-list-detail/department-list-detail.component';
// import * as _ from 'lodash';
import { finalize } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
var DepartmentListComponent = (function () {
    function DepartmentListComponent(apiService, translate, authService, modalService) {
        this.apiService = apiService;
        this.translate = translate;
        this.authService = authService;
        this.modalService = modalService;
        this.itemsPerPage = 40;
        this.modal = null;
        this.modalData = null;
        this.searchDepartmentID = '';
        this.searchDepartmentName = '';
        this.groups = [];
        this.currentPage = 1;
        this.loading = false;
        this.list = [];
        this.departmentDetails = [];
        this.test = [];
    }
    DepartmentListComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.subs = this.translate.onLangChange.subscribe(function (res) {
            _this.loadData();
        });
        this.loadData();
    };
    DepartmentListComponent.prototype.reload = function () {
        this.pageChanged();
    };
    DepartmentListComponent.prototype.pageChanged = function () {
        this.loadData();
    };
    DepartmentListComponent.prototype.optionChanged = function () {
        this.search();
    };
    DepartmentListComponent.prototype.openModal = function (data, index) {
        this.detailModal.open(this, data);
    };
    DepartmentListComponent.prototype.search = function () {
        this.currentPage = 1;
        this.loadData();
    };
    DepartmentListComponent.prototype.loadData = function () {
        var _this = this;
        this.loading = true;
        var data = {
            page: this.currentPage,
            items_per_page: this.itemsPerPage,
            code: this.searchDepartmentID || '',
            name: this.searchDepartmentName || '',
        };
        this.apiService.getDepartments(data)
            .pipe(finalize(function () {
            _this.loading = false;
        }))
            .subscribe(function (response) {
            _this.departmentDetails = response.results;
            _this.totalItems = response.count;
        });
    };
    DepartmentListComponent.prototype.revertBack = function () {
        this.modal.close();
        this.modal = null;
        this.modalData = null;
    };
    DepartmentListComponent.prototype.sniff = function (action, target) {
        var data = {
            action: action,
            address: 'MANAGE_DEPARTMENT',
            target: target
        };
        this.apiService.sniff(data).subscribe(function (res) {
        });
    };
    DepartmentListComponent.prototype.confirmDelete = function (index) {
        this.modalData = this.departmentDetails[index];
        this.modal = this.modalService.open(this.deleteConfirmationModal, { backdrop: 'static', centered: true });
    };
    DepartmentListComponent.prototype.confirmedDelete = function (productId) {
        var _this = this;
        this.apiService.deleteDepartment(productId).subscribe(function () {
            _this.loadData();
            _this.sniff('DELETE_DEPARTMENT', _this.modalData.name_en);
            _this.revertBack();
        });
    };
    DepartmentListComponent.prototype.clearSearch = function () {
        this.searchDepartmentID = '';
        this.searchDepartmentName = '';
        this.loadData();
    };
    DepartmentListComponent.prototype.ngOnDestroy = function () {
        this.subs.unsubscribe();
    };
    Object.defineProperty(DepartmentListComponent.prototype, "isAdmin", {
        get: function () {
            return this.authService.isAdmin();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DepartmentListComponent.prototype, "isIT", {
        get: function () {
            return this.authService.isIT();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DepartmentListComponent.prototype, "isAccountant", {
        get: function () {
            return this.authService.isAccountant();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DepartmentListComponent.prototype, "isAccountantAdmin", {
        get: function () {
            return this.authService.isAccountantAdmin();
        },
        enumerable: true,
        configurable: true
    });
    return DepartmentListComponent;
}());
export { DepartmentListComponent };



// WEBPACK FOOTER //
// /opt/app/src/app/features/department/department-list/department-list.component.ts.pre-build-optimizer.js